import React, { forwardRef, useEffect } from 'react';

import { setHelloBarCount } from 'actions/hellobar';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { selectReviewHelloBar } from 'selectors/hellobar';

import { ReviewsIconDualTone, ReviewsIconHover, ReviewsIconSelected } from 'assets/assetsV1/iconComponents';

import { HELLO_BAR_PAGE_TYPE, HELLO_BAR_PAGE_TYPE_2 } from 'constants/ProjectConstants';
import { getMatchesForCurrentRoute, goToReview } from 'constants/helper';
import { sendNavigatedToReviewsEvent } from 'constants/mixpanelHelpers/reviewsEvents';

import { getHelloBarDetails } from 'services/notifications';

import { SubNavItem } from 'uiToolkitV1/NavBar';

import { HeaderIconContainer } from './common/styles';

const ReviewNotificationSubMenu = forwardRef((props, ref) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const { isReviewMatch, isAnalyticsV0Match } = getMatchesForCurrentRoute(location.pathname, history.location);

  const reviewHelloBar = useSelector(selectReviewHelloBar);

  const getPendingRevieweesCount = () => {
    getHelloBarDetails({ pageType: HELLO_BAR_PAGE_TYPE.REVIEW })
      .then((res) => dispatch(setHelloBarCount({ param: HELLO_BAR_PAGE_TYPE_2.REVIEW, value: res.count })))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    getPendingRevieweesCount();
  }, [reviewHelloBar.refresh]);

  return (
    <HeaderIconContainer
      {...props}
      ref={ref}
      onClick={() => {
        sendNavigatedToReviewsEvent({ eventProperties: { source: 'topBar' } });
        goToReview(history);
      }}
    >
      <SubNavItem
        Icon={ReviewsIconDualTone}
        HoverIcon={ReviewsIconHover}
        ActiveIcon={ReviewsIconSelected}
        isActive={isReviewMatch && !isAnalyticsV0Match}
        notificationCount={reviewHelloBar?.count}
        title="Reviews"
        subTitle="Helps track feedback & performance evaluation"
      >
        Reviews
      </SubNavItem>
    </HeaderIconContainer>
  );
});

export default ReviewNotificationSubMenu;
